<script>
import {  nextTick, onBeforeUnmount, onMounted, ref } from "vue"
// Lib
import QrScanner from "qr-scanner"
import LineFunction from '@/helper/facade/LineFunction.js'

import Service from '../service/TransferPointService.js'
import mongoService from "../../../service/mongoService"; 
import useModalStore from "../stroe/ModalStore";
import { useErrorApi } from '@/feature/ErrorApiFeature.js'

export default {
    name: 'ScanQr',
    components: {
    },
    props: {
        lbl: Object,
        blobConfig: { type: Object },
        rate: { type: Object },
        modalController: { type: Object },
    },
    setup: function (props,ctx) {
        const lineFunction = new LineFunction()
        const ModalStore = useModalStore();
        const modalController =  ModalStore.methods.getModalController()
        const { errorApi } = useErrorApi(modalController)
        // Config Qr scanner
        const videoEl = ref(null)
        const hasCamera = ref(false)
        const scanner = ref()
        const result = ref()


        function init() {
            if ( props.blobConfig.query.liffId) {
                scanWithLine()
            } else {
                scanWiteLib()
            }
        }
        //#region handler
        const scanWiteLib = function () {
            QrScanner.hasCamera().then((hasDevices) => {
                // console.log("has camera", hasDevices)
                if (hasDevices) {
                    return QrScanner.listCameras()
                } else {
                    props.modalController.alertModal
                        .clearModal()
                        .setTitle("Can't access cameras devices")
                        .setMsg()
                        .setBtnCancel(props.lbl.alert.close_btn)
                        .show()
                    // throw new Error("can not access camera devices")
                }
            }).then((devices) => {
                // console.log(devices)
                if (devices && devices.length) {
                    var cameraId = devices[0].id;
                    nextTick(() => {
                        startScannerMode(cameraId)
                    })
                }
            }).catch(() => {
                // can not access camera device then go mode upload file
                // startFileMode()
            })
        }
        const scanWithLine = function() {
            let liffId = lineFunction.getLiffId(); 
            lineFunction.init(liffId).then(() => {
                lineFunction.scanQrCodeV2().then((res) => {
                    console.log(res)
                    result.value = res.value
                    apiQrLookup()
                }).catch((err) => {
                    console.log(err)
                    errorApi(err)
                })
            }).catch((err) => {
                console.log(err)
                props.modalController.alertModal
                        .clearModal()
                        .setTitle("Line liff error")
                        .setBtnCancel(props.lbl.alert.close_btn)
                        .show()
            })
        }
        const qrCodeSuccessCallback = function (decodedText, decodedResult) {
            console.log(`Code matched = ${decodedText}`, decodedResult)
            result.value = decodedText.data
            // alert(result.value)
            if (!result.value) return;

            apiQrLookup()
        }
        //#endregion handler
        //#region method
        function apiQrLookup() {
            props.modalController.loadingModal.show()

            var appMain = props.blobConfig.mainAppName;
            var apiPrefix = props.blobConfig.query.apiPrefix;
            var token = props.blobConfig.query.wallet_token;
            var jwt = props.blobConfig.query.jwt;
            // var campaignId = props.blobConfig.query.campaignId;
            var weblandingBlob = props.blobConfig.blobWebLanding;

            var theme = props.blobConfig.query.theme || "";
            var appName = props.blobConfig.query.appName || theme || "";
            var isDeductBzbsApp = props.blobConfig.query.isDeductBzbsApp;
            // Lookup api 
            
            Service.checkLookupQRcode(appMain, token, apiPrefix, weblandingBlob, props.blobConfig, isDeductBzbsApp, result.value, jwt).subscribe({
                next: (res) => {  
                    console.log(res)
                    props.modalController.loadingModal.hide()
                    mongoService.sendSuccessLogMongoDb(appName, theme, result.value, res);  
                    CheckQrStatement(res.data)
                },
                error: (err) => {
                    console.log(err)
                    errorApi(err)
                    mongoService.sendErrorLogMongoDb(err, result.value, appName, theme); 
                    props.modalController.loadingModal.hide()
                },
            })
        }

        function CheckQrStatement(statement){
            if(!statement) return;

                let pointToUse = statement.pointToUse;
                let amount = statement.amount;
                let userPoint = props.rate.CurrentPoints;
                let statements = statement;
                
                statements.qrID = result.value; //add qr Id
                
                // CheckPoint can redeem
                if (pointToUse && amount != null) {
                    if (userPoint < pointToUse) {
                        props.modalController.alertModal
                        .clearModal()
                        .setTitle(props.lbl.alert.point_not_enought_title)
                        .setMsg(props.lbl.alert.point_not_enought_msg)
                        .setBtnCancel(props.lbl.alert.close_btn)
                        .show()
                    }else{
                        ctx.emit('updatePaymentState', statements)
                    }
                }else{
                    ctx.emit('updatePaymentState', statements)
                }
        }

        function startScannerMode() {
            scanner.value = new QrScanner(videoEl.value, qrCodeSuccessCallback, {
                preferredCamera: "environment",
                highlightScanRegion: true,
                highlightCodeOutline: true,
            })
            scanner.value.setInversionMode('both');
            scanner.value.start().then(() => {
                hasCamera.value = true
            }).catch(() => {
                hasCamera.value = false
                props.modalController.alertModal
                        .clearModal()
                        .setTitle("Camera can't start")
                        .setMsg()
                        .setBtnCancel(props.lbl.alert.close_btn)
                        .show()
            })
        }

        function ToggleFlash(){
            if(scanner.value.hasFlash()){
                scanner.value.toggleFlash();
            }
        }

        function stopScannerMode() {
            if (scanner.value != null) {
                scanner.value.stop()
                scanner.value.destroy()
            }
        }

        function clickBack(){
            if (hasCamera.value) {
                stopScannerMode()
            }
            ctx.emit('selectState', 'selecting')
        }
        //#endregion method


        onMounted(()=> {
            init()
        })

        onBeforeUnmount(() => {
            if (hasCamera.value) {
                stopScannerMode()
            }
        })

        return {
            videoEl,
            clickBack,
            ToggleFlash,
        }
    }
}
</script>
<template>
        <div class=" bg-black" >
            <div class="w-full  flex items-center content-between justify-between absolute z-20 pr-6">
                <div class="bg-back pt-7 pl-5" @click="clickBack()">
                    <img class=" w-5" src="../assets/icon/pwp-ic-back-new.svg"/>
                </div>
                <div class="text-white text-20 font-bold">
                    Scan
                </div>
                <div @click="ToggleFlash()">
                    <img src="../assets/icon/ic-flash.svg" alt="flashlight" />
                </div>
            </div>
            <div id="video-container" class="styleTest h-full w-full z-10">
                <video allow="camera" id="qr-video" ref="videoEl" class=" w-full h-full "></video>
            </div>
        </div>
</template>


<style lang="scss" scoped>
@import '../style/base.scss';

#qr-video {
  width: 100% !important;
  height: 100vh !important;
  height: 100svh !important; //if broswer support svh it wll use svh instant of vh
  object-fit: cover;

}

.styleTest{
    :deep(.scan-region-highlight) {
        border-radius: 30px;
        outline: rgba(0, 0, 0, .25) solid 50vmax !important
      }
      
    :deep(.scan-region-highlight-svg) {
        stroke: #ffffff !important;
    }
  }


.bg-back {
    width: 80px;
    height: 72px;
    background-color: #080909;
    border-bottom-right-radius: 40px;
}
.voucher-container {
    min-height: max-content;
    max-width: $max-width-l-mobile;
}
.voucher-header {
    padding: 66px 0 14px;
    @include tablet {
        padding: 60px 0 14px;
    }
}
.font-SemiBold {
    font-family: $ff-semi;
}
.font-Text {
    font-family: $ff-text;
}
.border-line {
    border-bottom: 2px dashed;
    border-color: #cccccc;
}

</style>
